import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { infra } from '@photo-vault/shared';
import { createInfraProvider } from './provider.js';

const InfraContext = createContext<infra.InfraProvider | undefined>(undefined);

export function InfraProviderRoot({
  children,
  provider,
}: {
  children: ReactNode;
  // Override hook for tests/storybook. Production uses the build-time
  // factory.
  provider?: infra.InfraProvider;
}) {
  const value = useMemo<infra.InfraProvider>(() => provider ?? createInfraProvider(), [provider]);
  return <InfraContext.Provider value={value}>{children}</InfraContext.Provider>;
}

export function useInfra(): infra.InfraProvider {
  const ctx = useContext(InfraContext);
  if (!ctx) throw new Error('useInfra must be used inside InfraProviderRoot');
  return ctx;
}
